import React, { Component, Fragment } from 'react';
import moment from 'moment';
import { Query } from '../../reactApolloCompat';
import gql from 'graphql-tag';
import withStyles from '@mui/styles/withStyles';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import TextField from '../../components/form/TextField';
import ColumnLayout from '../../components/layout/ColumnLayout';
import Grid from '../../components/layout/Grid';
import Button from '../../components/form/Button';
import CremationOrderFragment from '../../fragments/CremationOrder';
import NotesReadOnly from '../../components/form/NotesReadOnly';
import StaffAutoComplete from '../../components/form/StaffAutoComplete';
import Inline, { inlineAlignment } from '../../components/layout/Inline';
import AlertBar from '../../components/form/AlertBar';
import UserCircle from '../../components/form/UserCircle';
import AlertModal from '../../components/modal/AlertModal';
import ReadonlyField from '../../components/form/ReadonlyField';
import { getFinalInsertionDate, MAX_INSERTION_HOURS, niceDateFromString } from '../../utils/date';
import { EditIcon, TickCircleIcon } from '../../components/IconIndex';

const maxHours = MAX_INSERTION_HOURS;
const setFinalInsertionDate = (form) => {
    const dateReq = form.getField('CremationDate');
    const dateAct = form.getField('DeliveryDate');
    const dateEst = form.getField('EstimatedDeliveryDate');
    const dateIns = form.getField('EstimatedInsertionDate');
    const sameDay = form.getField('SameDayCremation');
    if (sameDay) {
        // form.setField({ EstimatedInsertionDate: dateAct || dateEst || dateReq });
    } else if (!dateIns) {
        // form.setField({ EstimatedInsertionDate: dateReq });
    }
    if (sameDay) return (dateAct || dateEst || dateReq);
    return getFinalInsertionDate(dateAct || dateEst || dateReq);
};

class CremationActionTab extends Component {
    state = {
        editCR: true,
        showConfirmComplete: false
    };

    static getDerivedStateFromProps(newProps, oldState) {
        const { form } = newProps;
        const { currentRecordID } = oldState;
        if (!currentRecordID && form) {
            const setRecordID = form.getField('ID');
            // const finalInsertionDate = setFinalInsertionDate(form);
            return ({
                currentRecordID: setRecordID
                // finalInsertionDate
            });
        }
        return null;
    }

    render() {
        const { form } = this.props;
        const { showConfirmComplete } = this.state;
        const isPending = !!form.getField('CremationPending');
        return (
            <Fragment>
                <ColumnLayout>
                    {this.renderLeftColumn()}
                    {isPending ? (
                        <Grid container>
                            <Grid container bucket>
                                <Grid item>
                                    <h4>Cremation Action</h4>
                                </Grid>
                                <Grid item>
                                    <p>Cremation Action is not possible on a pending order.</p>
                                </Grid>
                            </Grid>
                        </Grid>
                    ) : (
                        this.renderRightColumn()
                    )}
                </ColumnLayout>
                <AlertModal
                    variant="save"
                    open={showConfirmComplete}
                    title="Prompt"
                    primaryAction="Yes, Mark as Complete"
                    onClickPrimaryAction={() => this.handleMarkCremationAsComplete()}
                    secondaryAction="Actually, not just yet"
                    onClickSecondaryAction={() => this.setState({ showConfirmComplete: false })}
                    onClose={() => this.setState({ showConfirmComplete: false })}
                >
                    <p>You're about to mark this cremation as complete.</p>
                    <p>Are you sure?</p>
                </AlertModal>
            </Fragment>
        );
    }

    renderLeftColumn() {
        return (
            <Fragment>
                {this.renderDeliveryDate()}
                {this.renderCremationActionNotes()}
            </Fragment>
        );
    }

    renderDeliveryDate() {
        const { form } = this.props;

        return (
            <Fragment>
                <Grid container bucket>
                    <Grid item>
                        <Inline alignment={inlineAlignment.rightAlignSiblings} center>
                            <h4>Scheduled Arrival</h4>
                        </Inline>
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        <TextField
                            label="Expected Arrival Date"
                            type="date"
                            form={form}
                            name="EstimatedDeliveryDate"
                            onChange={this.handleFinalInsertion}
                        />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        <TextField
                            label="Expected Arrival Time"
                            type="time"
                            form={form}
                            name="EstimatedDeliveryTime"
                            onChange={this.handleFinalInsertion}
                        />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        <TextField
                            label="Estimated Deceased Weight"
                            type="number"
                            form={form}
                            name="EstimatedDeceasedWeight"
                            InputProps={{ startAdornment: <InputAdornment position="start">KG</InputAdornment> }}
                        />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        <TextField
                            label="Delivery by whom"
                            form={form}
                            name="EstimatedDeliveredBy"
                        />
                    </Grid>
                </Grid>

                <Grid container bucket>
                    <Grid item>
                        <h4>Delivery Received</h4>
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        <TextField label="Actual Delivery Date" type="date" form={form} name="DeliveryDate"
                                   onChange={this.handleFinalInsertion} />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        <TextField label="Actual Delivery Time" type="time" form={form} name="DeliveryTime"
                                   onChange={this.handleFinalInsertion} />
                    </Grid>

                    <Grid item margin="-18px 0 0 0">
                        <Button
                            variant="link-orange"
                            onClick={() => this.insertDateAndTime('DeliveryDate', 'DeliveryTime')}
                        >
                            Insert current date and time
                        </Button>
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        <TextField
                            label="Actual Deceased Weight" type="number" form={form} name="DeceasedWeight"
                            InputProps={{ startAdornment: <InputAdornment position="start">KG</InputAdornment> }}
                        />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        {this.renderDeliveryReceivedByField()}
                    </Grid>
                </Grid>
            </Fragment>
        );
    }

    renderDeliveryReceivedByField() {
        const { form } = this.props;
        const deliveryReceivedBy = form.getState('DeliveryReceivedBy');
        if (!!deliveryReceivedBy) {
            return (
                <ReadonlyField label="Delivery Received By">
                    <UserCircle
                        member={deliveryReceivedBy}
                        onDelete={() =>
                            this.handleDeleteStaff('DeliveryReceivedBy')
                        }
                    />
                </ReadonlyField>
            );
        }

        return (
            <StaffAutoComplete
                label="Delivery Received By Whom"
                placeholder="Search by name..."
                selectProps={{ multiple: false }}
                onSelect={(_, user) => this.handleSelectStaff('DeliveryReceivedBy', user)}
                form={form}
                name="DeliveryReceivedBy"
            />
        );
    }

    renderRightColumn() {
        const { form } = this.props;
        const query = gql`
            query ReadOneCremationReady($id: ID!) {
                readOneCremationOrder(ID: $id){
                    ID
                    ReadyForCremation
                }
            }
        `;
        return (
            <Query query={query} variables={{ id: form.getState('ID') }} fetchPolicy="network-only">
                {({ data }) => {
                    const readOneCremationOrder = data && data.readOneCremationOrder;
                    const { ReadyForCremation } = readOneCremationOrder || {};
                    return (<>
                        {this.renderInsertionDate()}
                        {this.renderCremationStartDate(ReadyForCremation)}
                        {this.renderCRNumber()}
                        {this.renderCremationEndDate(ReadyForCremation)}
                    </>);
                }}
            </Query>
        );
    }

    renderInsertionDate() {
        const { form } = this.props;
        const finalInsertionDate = setFinalInsertionDate(form);
        const sameDayCremation = form.getField('SameDayCremation');
        const nextDayCremation = form.getField('NextDayCremation');
        const witnessCremation = 'Required' === form.getField('WitnessOfInsertionRequired');
        return (
            <>
                <Grid container bucket>
                    <Grid item>
                        <h4>Scheduled Insertion</h4>
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        <TextField
                            label="Expected Insertion Date"
                            type="date"
                            form={form}
                            name="EstimatedInsertionDate"
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <TextField
                            label="Expected Insertion Time"
                            type="time"
                            form={form}
                            name="EstimatedInsertionTime"
                        />
                    </Grid>

                    <Grid item xs={12} sm={12}>
                        <p>
                            Insertion is required {!sameDayCremation
                            ? <>max {maxHours} hours after</>
                            : 'SAME DAY as'} delivery.
                            <br /><strong>Final Insertion: </strong>
                            {!finalInsertionDate ? 'Pending delivery' : niceDateFromString(finalInsertionDate)}
                        </p>
                        {(!!sameDayCremation || !!nextDayCremation || !!witnessCremation) && (
                            <div style={{ marginBottom: '-1rem' }}>
                                {!!sameDayCremation && (
                                    <AlertBar variant="warning">Same-day Cremation</AlertBar>
                                )}
                                {!!nextDayCremation && (
                                    <AlertBar variant="info">Priority Cremation</AlertBar>
                                )}
                                {!!witnessCremation && (
                                    <AlertBar variant="fire">Witness of Insertion</AlertBar>
                                )}
                            </div>
                        )}
                    </Grid>
                </Grid>
            </>
        );
    }

    renderCremationStartDate(readyForCremation) {
        const { form } = this.props;
        const missing = form.getField('HasMissingCertificates');
        const actionComplete = form.getState('CremationComplete') || form.getField('CremationNumber');
        const hadPacemaker = !!form.getField('HadPacemaker');
        const hadPacemakerRemoved = !!form.getField('HadPacemakerRemoved');
        const showInsertion = !!actionComplete || (!!readyForCremation && (!hadPacemaker || !!hadPacemakerRemoved));
        return (
            <>
                <Grid container bucket>
                    <Grid item>
                        <h4>Action Start</h4>
                    </Grid>
                    {(!!missing && !readyForCremation &&
                        <Grid item>
                            <p>
                                Cannot start until marked as Cremation Ready.<br />
                                Please check the Summary tab for details.
                            </p>
                        </Grid>
                    ) || (
                        <Grid item>
                            {!readyForCremation ? (
                                <p>Order is not marked as Cremation Ready.</p>
                            ) : !!actionComplete ? (
                                <p>Order was marked as Cremation Ready.</p>
                            ) : (
                                <div style={{ margin: '-1rem 0' }}><AlertBar variant="success">
                                    Order is marked as Cremation Ready.
                                </AlertBar></div>
                            )}
                        </Grid>
                    )}
                    {this.renderCremationOperator()}
                    {!!showInsertion && (
                        <>
                            <Grid item xs={12}>
                                <h5>Insertion</h5>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <TextField label="Actual Insertion Date" type="date" form={form} name="InsertionDate" />
                            </Grid>

                            <Grid item xs={12} sm={6}>
                                <TextField label="Actual Insertion Time" type="time" form={form} name="InsertionTime" />
                            </Grid>

                            <Grid item margin="-18px 0 0 0">
                                <Button
                                    variant="link-orange"
                                    onClick={() => this.insertDateAndTime('InsertionDate', 'InsertionTime')}
                                >
                                    Insert current date and time
                                </Button>
                            </Grid>
                        </>
                    )}
                    {!!hadPacemaker && (
                        <Grid item>
                            <div style={{ margin: '-1rem 0' }}>
                                {!!hadPacemakerRemoved ? (<AlertBar variant="info">
                                    A pacemaker was removed.
                                </AlertBar>) : (<AlertBar variant="error">
                                    A pacemaker was not removed.
                                </AlertBar>)}
                            </div>
                        </Grid>
                    )}
                </Grid>
            </>
        );
    }

    renderCRNumber() {
        const { form } = this.props;
        const { editCR } = this.state;
        return (
            <Grid container bucket>
                <Grid item>
                    <Inline alignment={inlineAlignment.rightAlignSiblings} center>
                        <h4>Cremation Number</h4>
                        <IconButton
                            className="icon"
                            title={!!editCR ? 'Edit' : 'Accept'}
                            onClick={() => this.setState({ editCR: !editCR })} size="large">
                            {!!editCR ? <EditIcon /> : <TickCircleIcon />}
                        </IconButton>
                    </Inline>
                </Grid>
                <Grid item>
                    {((!editCR || !!form.getField('CremationNumber')) && (
                        <TextField
                            label="CR Number"
                            placeholder="Update CR Number..."
                            type="number"
                            form={form}
                            name="CremationNumber"
                            readOnly={!!editCR}
                        />
                    )) || <ReadonlyField label="CR Number">Not yet generated</ReadonlyField>}
                </Grid>
            </Grid>
        );
    }

    renderCremationEndDate(readyForCremation) {
        const { form } = this.props;
        const actionComplete = form.getState('CremationComplete') || form.getField('CremationNumber');
        return (
            <Grid container bucket>
                <Grid item>
                    <h4>Action End</h4>
                </Grid>

                {((!!readyForCremation || !!actionComplete) && (
                    <Fragment>
                        <Grid item xs={12} sm={6}>
                            <TextField label="End Date" type="date" form={form} name="CremationEndDate" />
                        </Grid>

                        <Grid item xs={12} sm={6}>
                            <TextField label="End Time" type="time" form={form} name="CremationEndTime" />
                        </Grid>

                        <Grid item margin="-18px 0 0 0">
                            <Button
                                variant="link-orange"
                                onClick={() => this.insertDateAndTime('CremationEndDate', 'CremationEndTime')}
                            >
                                Insert current date and time
                            </Button>
                        </Grid>

                        {this.renderCremationCompleteField(readyForCremation)}
                    </Fragment>
                )) || (
                    <Grid item>
                        <p>Order is not marked as Cremation Ready.</p>
                    </Grid>
                )}
            </Grid>
        );
    }

    renderCremationOperator() {
        return (
            <>
                <Grid item>
                    <h5>Cremation Operator</h5>
                </Grid>
                <Grid item>
                    {this.renderCremationOperatorField()}
                </Grid>
            </>
        );
    }

    renderCremationOperatorField() {
        const { form } = this.props;
        const cremationOperator = form.getState('CremationOperator');
        if (!!cremationOperator) {
            return (
                <UserCircle
                    tiny={false}
                    member={cremationOperator}
                    onDelete={() =>
                        this.handleDeleteStaff('CremationOperator')
                    }
                />
            );
        }

        return (
            <StaffAutoComplete
                placeholder="Search for a staff name here"
                selectProps={{ multiple: false }}
                onSelect={(_, user) => this.handleSelectStaff('CremationOperator', user)}
                form={form}
                name="CremationOperator"
            />
        );
    }

    renderCremationActionNotes() {
        const { form } = this.props;

        return (
            <Grid container bucket>
                <Grid item>
                    <h4>Cremation Action Notes</h4>
                </Grid>

                <Grid item>
                    <TextField
                        placeholder="Notes are written here..."
                        multiline
                        name="CremationActionNotes"
                        form={form}
                        button={{ children: '+ Add Note' }}
                    />
                </Grid>

                {form.getField('OldCremationActionNotes') && (
                    <Grid item>
                        <NotesReadOnly name="OldCremationActionNotes" form={form} />
                    </Grid>
                )}
            </Grid>
        );
    }

    renderCremationCompleteField(readyForCremation) {
        const { form } = this.props;

        if (form.getState('CremationComplete')) {
            return (
                <Grid item>
                    <Inline>
                        <AlertBar variant="success">This cremation is marked as complete.</AlertBar>
                    </Inline>
                </Grid>
            );
        }

        return (
            <Grid item>
                <Button
                    disabled={form.isDirty || form.getField('CremationPending') || !readyForCremation}
                    variant="urgent"
                    onClick={() => this.setState({ showConfirmComplete: true })}
                >
                    Mark as Cremation Completed...
                </Button>
            </Grid>
        );
    }

    handleMarkCremationAsComplete() {
        const { form } = this.props;

        form.setState({ CremationComplete: true });
        form.save();
        this.setState({ showConfirmComplete: false });
    }

    insertDateAndTime(dateFieldName, timeFieldName) {
        const { form } = this.props;

        form.setState({
            [dateFieldName]: moment().format('YYYY-MM-DD'),
            [timeFieldName]: moment().format('HH:mm')
        });
    }

    handleSelectStaff(propertyName, staff) {
        const { form } = this.props;

        if (!!staff) {
            delete staff['__typename'];
            form.setState({ [propertyName]: staff });
        } else {
            this.handleDeleteStaff(propertyName);
        }
    }

    handleDeleteStaff(propertyName) {
        const { form } = this.props;

        form.setState({
            [propertyName]: null
        });
    }

    handleFinalInsertion = () => {
        const { form } = this.props;
        setFinalInsertionDate(form);
    };
}

export default {
    id: 'CremationAction',
    label: 'Cremation Action',
    component: withStyles({})(CremationActionTab),
    fragment: CremationOrderFragment,
    onLoad: data => {
        // create a stub to detect new notes on save!
        if (!!data.CremationActionNotes) {
            data.OldCremationActionNotes = '' + (data.CremationActionNotes || '');
        }
        data.CremationActionNotes = null;
    },
    formatSaveData: (saveData, state) => {
        if (saveData.CremationOperator === null) {
            saveData.CremationOperatorID = null;
            delete saveData['CremationOperator'];
        }
        if (saveData.DeliveryReceivedBy === null) {
            saveData.DeliveryReceivedByID = null;
            delete saveData['DeliveryReceivedBy'];
        }
        if (!state.CremationNumber) {
            saveData.CremationNumber = 0; // can't be empty.
        }
    }
};
